import { render, staticRenderFns } from "./SidebarDocument.vue?vue&type=template&id=38afcc24&scoped=true&"
import script from "./SidebarDocument.vue?vue&type=script&lang=js&"
export * from "./SidebarDocument.vue?vue&type=script&lang=js&"
import style0 from "./SidebarDocument.vue?vue&type=style&index=0&id=38afcc24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38afcc24",
  null
  
)

export default component.exports